export class DateHelper {
    static getDateFromBackIntervalFromToday(value) {
        const end = this.getYearMonthDayString(new Date());
        const intervalExp = value.trim();
        const intervalType = intervalExp.at(-1);
        const intervalValue = parseInt(intervalExp.slice(0, intervalExp.length - 1), 10);
        const dateArray = end.split('-');
        let year = Number(dateArray[0]);
        let month = Number(dateArray[1]);
        const day = Number(dateArray[2]);
        const milisecondsInDay = 24 * 60 * 60 * 1000;
        let startDate = Date.now().toString();
        let endDate = Date.now().toString();
        if (intervalType === 'y') {
            year -= intervalValue;
            startDate = this.getYearMonthDayString(new Date(year, month - 1, day));
        }
        else if (intervalType === 'm') {
            year -= Math.floor(intervalValue / 12);
            if (intervalValue % 12 < month) {
                month -= intervalValue % 12;
            }
            else {
                month = 12 + month - (intervalValue % 12);
                year -= 1;
            }
            startDate = DateHelper.getYearMonthDayString(new Date(year, month - 1, day));
        }
        else if (intervalType === 'd') {
            startDate = DateHelper.getYearMonthDayString(new Date(new Date().getTime() - (intervalValue - 1) * milisecondsInDay));
        }
        endDate = end;
        return { startDate, endDate };
    }
}
/**
 * Returns a string with date in ISO format 'yyyy-mm-dd' from a date.
 * @param date Date to compute.
 * @returns String with date in ISO format 'yyyy-mm-dd'.
 */
DateHelper.getYearMonthDayString = (date) => {
    const yyyy = date.getFullYear();
    const mm = (date.getMonth() + 101).toString().substring(1);
    const dd = (date.getDate() + 100).toString().substring(1);
    return `${yyyy}-${mm}-${dd}`;
};
//# sourceMappingURL=dateHelper.js.map